/**
 * The pricing section's three panels, split out of `pricing.tsx` so the navbar
 * can name one without pulling the whole section — and its client bundle —
 * into the header.
 *
 * The drawer's pricing sub-links jump to `#pricing` like any anchor and then
 * announce which tab they meant on `PRICING_PANEL_EVENT`. A window event
 * rather than shared state or a `?panel=` query: the section owns its own tab,
 * this only nudges it, and a link that lands on the wrong tab is a cosmetic
 * miss rather than a broken page if the section happens not to be listening.
 */
export const PANELS = ["crm", "pos-monthly", "pos-kit"] as const;

export type PanelId = (typeof PANELS)[number];
export type PosPanelId = Exclude<PanelId, "crm">;

export const PRICING_PANEL_EVENT = "jd:pricing-panel";
